import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import ssserviciosLogo from "./img/logo.png";

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: "",
    });

    api
      .userPassLogin(
        {
          username,
          password
        },
        parameters
      )
      .then((response) => {
        setOnLogin(false);
        window.location =
          parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false);
        setError({ open: true, message: message });
      });
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <>
        <div className="ssservicios-container" ref={nodeRef}>
          <div className="ssservicios-logoForm-container">
            <Form onSubmit={(event) => onSubmit(event)} className="ssservicios-form">
              <img src={ssserviciosLogo} alt="ssservicios-logo" className="ssserviciosLogo" />
              <p className="text-form">{translate("Header")}</p>
              <input
                className="ssserviciosInput usernameInput input"
                disabled={onLogin}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                id="username"
                onChange={(e) => setUsername(e.target.value)}
                placeholder={translate("PlaceholderUserName")}
              />
              <input
                className="ssserviciosInput passwordInput input"
                required={true}
                disabled={onLogin}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password"
                placeholder={translate("PlaceholderPassword")}
                onChange={(e) => setPassword(e.target.value)}
              />
              {!onLogin ? (
                <div className="ssservicios-submit-container">
                  <button
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="ssserviciosSubmit"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                  {/* Reincluir cuando el cliente envíe el enlace de cambio de contraseña
                  <a
                    href="#"
                    className="ssservicios-change-password-link"
                  >
                    {translate("ChangePassword")}
                  </a>
                  */}
                </div>

              ) : (
                <Progress animated color="danger" value={100} />
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </Form>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </div>
        </div>
        <div className="ssservicios-illustration"></div>
      </>
    </CSSTransition>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
